import { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';

const JsonEditor = ({ value, onChange, isPassword, showPassword }) => {
  const [jsonString, setJsonString] = useState('');
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    if (value) {
      try {
        // Se o valor já for um objeto, converta-o para string formatada
        if (typeof value === 'object') {
          setJsonString(JSON.stringify(value, null, 2));
        } else {
          // Tente analisar o valor e depois formatar (para garantir a formatação)
          const parsed = JSON.parse(value);
          setJsonString(JSON.stringify(parsed, null, 2));
        }
        setIsValid(true);
        setErrorMessage('');
      } catch (e) {
        // Se não puder ser analisado como JSON, use o valor bruto
        setJsonString(value);
        setIsValid(false);
        setErrorMessage('JSON inválido');
      }
    } else {
      setJsonString('');
      setIsValid(true);
      setErrorMessage('');
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    setJsonString(newValue);
    
    try {
      if (newValue.trim()) {
        // Tenta analisar como JSON
        JSON.parse(newValue);
        setIsValid(true);
        setErrorMessage('');
        onChange(newValue); // Passa a string JSON para o manipulador onChange
      } else {
        setIsValid(true);
        setErrorMessage('');
        onChange(''); // Se vazio, passe string vazia
      }
    } catch (e) {
      setIsValid(false);
      setErrorMessage(e.message);
      onChange(newValue); // Ainda passamos o valor atual, mesmo que inválido
    }
  };

  return (
    <div className="relative">
      <div className={`border ${isValid ? 'border-gray-300' : 'border-red-500'} rounded-md shadow-sm relative`}>
        {isPassword && !showPassword ? (
          <div className="min-h-[100px] max-h-[300px] overflow-auto bg-gray-100 p-3 font-mono text-sm">
            ••••••••••••••••••••••••••••••••••••••••••••••
            ••••••••••••••••••••••••••••••••••••••••••••••
            ••••••••••••••••••••••••••••••••••••••••••••••
          </div>
        ) : (
          <textarea
            value={jsonString}
            onChange={handleChange}
            className="w-full min-h-[100px] max-h-[300px] p-3 font-mono text-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 resize-y"
            style={{
              fontFamily: 'monospace',
              whiteSpace: 'pre',
              overflowWrap: 'normal',
              overflowX: 'auto'
            }}
          />
        )}
      </div>
      {!isValid && (
        <div className="mt-1 flex items-center text-red-600 text-xs">
          <AlertCircle className="w-3.5 h-3.5 mr-1" />
          <span>{errorMessage}</span>
        </div>
      )}
      {isValid && (
        <div className="mt-1 text-xs text-gray-500">
          Insira um objeto JSON válido. Use chaves {} e aspas duplas para nomes de propriedades.
        </div>
      )}
    </div>
  );
};

export default JsonEditor;